exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".menu-template-1{fill:#f2faf9}.menu-template-2{fill:#72cac2}.menu-template-2,.menu-template-3,.menu-template-4{opacity:.828;isolation:isolate}.menu-template-3{fill:#fbe57f}.menu-template-4{fill:#ee7470}.menu-template-5{fill:#1e4e69}\n", ""]);
